import {
  Container,
  Grid,
  Paper,
  useTheme,
  makeStyles,
  Link as MuiLink,
  Avatar,
} from '@material-ui/core'
import Layout from '../components/common/Layout'
import PhoneIcon from '@material-ui/icons/Phone'
import MailOutlineIcon from '@material-ui/icons/MailOutline'

import { useRouter } from 'next/router'
import ContactNew from '../components/pages-new/ContactNew'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

const useStyles = makeStyles((theme) => ({
  page: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  cards: {
    '& h4': {
      margin: `0 0 ${theme.spacing(1)}px 0`,
      fontWeight: 500,
      fontSize: 16,
    },
    '& p': {
      margin: `0 0 ${theme.spacing(1)}px 0`,
      fontSize: 16,
      color: '#828282',
    },
    '& a': {
      margin: `0 0 ${theme.spacing(1)}px 0`,
      fontSize: 16,
      color: theme.palette.primary.main,
    },
    [theme.breakpoints.up('sm')]: {
      padding: `${theme.spacing(4)}px 0`,
    },
  },
  cardGrid: {
    padding: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      paddingTop: theme.spacing(6),
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  paper: {
    padding: theme.spacing(3),
    height: '100%',
    borderRadius: '10px !important',
    position: 'relative',
    ...theme.homeStyle.boxShadow,
    margin: `${theme.spacing(2)}px 0`,
  },
  gridInCard: {
    width: '100%',
  },
  heroImg: {
    background:
      'linear-gradient(to right, rgba(0, 0, 0, 0.8), rgba(0,0,0,0)),url("/static/img/contact-us/contact-us-hero-img.jpg")',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    height: theme.homeStyle.heroImageHeightDesktop,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    color: 'white',
    '& h1': {
      ...theme.homeStyle.heroTitle,
      marginTop: 0,
      marginBottom: theme.spacing(3),
    },
    '& h2': {
      ...theme.homeStyle.heroSubtitle,
      [theme.breakpoints.up('sm')]: {
        maxWidth: '50%',
      },
    },
    [theme.breakpoints.down('sm')]: {
      padding: `${theme.spacing(1)}px ${theme.spacing(5)}px`,
    },
    [theme.breakpoints.down('xs')]: {
      background:
        'linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 1)),url("/static/img/contact-us/contact-us-hero-img-mobile.jpg")',
      height: theme.homeStyle.heroImageHeightMobile,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      padding: `${theme.spacing(2)}px 0`,
    },
  },
  mapWrapper: {
    [theme.breakpoints.up('sm')]: {
      width: '100%',
      height: 400,
      marginBottom: theme.spacing(1),
    },
    [theme.breakpoints.down('xs')]: {
      height: 375,
      padding: 0,
    },
  },
  spacer2: {
    height: theme.spacing(4),
  },
  spacer1: {
    height: theme.spacing(2),
  },
  mapTitle: {
    ...theme.homeStyle.title,
    width: '100%',
    textAlign: 'left',
    margin: `${theme.spacing(5)}px 0 ${theme.spacing(3)}px !important`,
  },
  iconAvatar: {
    backgroundColor: theme.palette.primary.main,
    width: 70,
    height: 70,
    position: 'absolute',
    top: -35,
    left: theme.spacing(3),
    ...theme.homeStyle.boxShadow,
  },
}))

const CardWithIcon = ({ iconComponent, children }) => {
  const classes = useStyles()

  return (
    <Paper className={classes.paper}>
      <Avatar className={classes.iconAvatar}>{iconComponent}</Avatar>
      <div className={classes.spacer2} />
      {children}
    </Paper>
  )
}

const ContactUsPageOld = () => {
  const theme = useTheme()

  const classes = useStyles()
  const { t } = useTranslation('contact-us')

  const renderHeroImage = () => (
    <div className={classes.heroImg}>
      <Container>
        <h1>{t('contact-us')}</h1>
        <h2>{t('address')}</h2>
        <h2>{t('tax-id')}</h2>
      </Container>
    </div>
  )

  const renderCards = () => (
    <Container className={classes.cards}>
      <Grid container justify="center">
        <Grid item xs={12} sm={6} md={4} className={classes.cardGrid}>
          <CardWithIcon iconComponent={<PhoneIcon fontSize="large" />}>
            <h4>Call center</h4>
            <p>
              {t('every-day')}
              <br />
              {t('call-time')}
              <br />
              {t('call-center-phone-no')}
            </p>
            <div className={classes.spacer2} />
            <h4>{t('accounting-problem')}</h4>
            <p>
              {t('mon-to-fri')}
              <br />
              {t('call-time')}
              <br />
              {t('acc-phone-no')}
            </p>
          </CardWithIcon>
        </Grid>
        <Grid item xs={12} sm={6} md={4} className={classes.cardGrid}>
          <CardWithIcon iconComponent={<MailOutlineIcon fontSize="large" />}>
            <h4>{t('contact-for-information')}</h4>
            <MuiLink href="mailto:cs@shippop.com" target="_blank">
              cs@shippop.com
            </MuiLink>
            <div className={classes.spacer1} />
            <h4>{t('contact-cs')}</h4>
            <MuiLink href="mailto:cs@shippop.com" target="_blank">
              cs@shippop.com
            </MuiLink>
            <div className={classes.spacer1} />
            <h4>{t('contact-sales')}</h4>
            <MuiLink href="mailto:sale@shippop.com" target="_blank">
              sale@shippop.com
            </MuiLink>
            <div className={classes.spacer1} />
            <h4>{t('contact-acc')}</h4>
            <MuiLink href="mailto:bill@shippop.com" target="_blank">
              bill@shippop.com
            </MuiLink>
            <div className={classes.spacer1} />
            <h4>{t('contact-hr')}</h4>
            <MuiLink href="mailto:job@shippop.com" target="_blank">
              job@shippop.com
            </MuiLink>
          </CardWithIcon>
        </Grid>
        <Grid item xs={12} sm={6} md={4} className={classes.cardGrid}>
          <Paper className={classes.paper}>
            <Grid container spacing={3} className={classes.gridInCard}>
              <Grid item xs={2}>
                <img src="/static/img/icons/facebook.svg" alt="facebook" />
              </Grid>
              <Grid item xs={10}>
                <MuiLink
                  href="https://www.facebook.com/shippop.official"
                  target="_blank"
                  rel="noreferrer"
                >
                  facebook.com/shippop
                </MuiLink>
              </Grid>
              <Grid item xs={2}>
                <img src="/static/img/icons/instagram.svg" alt="instagram" />
              </Grid>
              <Grid item xs={10}>
                <MuiLink
                  href="https://instagram.com/shippopcom"
                  target="_blank"
                  rel="noreferrer"
                >
                  instagram.com/shippopcom
                </MuiLink>
              </Grid>
              <Grid item xs={2}>
                <img src="/static/img/icons/youtube.svg" alt="youtube" />
              </Grid>
              <Grid item xs={10}>
                <MuiLink
                  href="https://www.youtube.com/channel/UCqthHHdPcpFlI8gTA6TAOdw"
                  target="_blank"
                  rel="noreferrer"
                >
                  youtube.com/shippop
                </MuiLink>
              </Grid>
              <Grid item xs={2}>
                <img src="/static/img/icons/line.svg" alt="line" />
              </Grid>
              <Grid item xs={10}>
                <MuiLink
                  href="https://line.me/ti/p/%40shippop"
                  target="_blank"
                  rel="noreferrer"
                >
                  @shippop ({t('includes')}@)
                </MuiLink>
              </Grid>
              <Grid item xs={2} />
              <Grid item xs={10}>
                <a href="https://line.me/ti/p/%40shippop" target="_blank">
                  <img
                    src="/static/img/qr_line.png"
                    alt="line"
                    width="100"
                    height="100"
                  />
                </a>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  )

  const renderMap = () => (
    <>
      <Container>
        <h1 className={classes.mapTitle}>{t('shippop-map')}</h1>
      </Container>
      <Container className={classes.mapWrapper}>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3875.3750373929224!2d100.53059681483055!3d13.756242690344589!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30e29dcac68f485b%3A0xea40d33d9f43987b!2sSHIPPOP!5e0!3m2!1sth!2sth!4v1604306315540!5m2!1sth!2sth"
          width="100%"
          height="100%"
          frameBorder="0"
          style={{ border: 0 }}
          allowFullScreen=""
          aria-hidden="false"
          tabIndex="0"
        />
      </Container>
    </>
  )

  return (
    <div className={classes.root}>
      <Layout
        title="ติดต่อเรา - SHIPPOP ส่งของ ส่งพัสดุ เปรียบเทียบราคา จองขนส่ง ทำได้เลยทันที"
        keywords="บริการส่งพัสดุ, SHIPPOP, บริการขนส่ง, ส่งของ, ส่งพัสดุ"
        description="บริษัท​ ชิปป๊อป​ จำกัด​ (สำนักงานใหญ่)​ SHIPPOP บริการส่งพัสดุ ส่งของ เปรียบเทียบราคาขนส่ง รวมบริการที่ทำให้การส่งพัสดุเป็นเรื่องง่าย ติดต่อปัญหาทั่วไป, ติดต่อฝ่ายบริการลูกค้า, ติดต่อฝ่ายขาย, ติดต่อฝ่ายบัญชี"
      >
        <div className={classes.page}>
          {renderHeroImage()}
          {renderCards()}
          {renderMap()}
        </div>
      </Layout>
    </div>
  )
}

export const getServerSideProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, [
      'common',
      'header',
      'footer',
      'pdpa',
      'contact-us',
    ])),
  },
})

// ?new → new-design variant (new chrome, same content); otherwise the old
// page renders unchanged. Wrapper keeps hook order stable across both paths
// (each branch is its own component, so neither shares the other's hooks).
const ContactUsPage = (props) => {
  const { query } = useRouter()
  if ('old' in query) return <ContactUsPageOld {...props} />
  return <ContactNew {...props} />
}

export default ContactUsPage
